import React from "react";
import { Link, useLocation } from "react-router-dom";
import Header from "../sections/Header";
import Sidebar from "../sections/Sidebar";
import Msgalert from "../views/Msgalert";
import { encStorage } from "../hooks/encStorage";
import { GET_WITHDRAWALS } from "../services/Apis";
import axios from "axios";
import { useEffect, useState } from "react";

const Withdraw = () => {
  const [SidebarState, setSidebarState] = useState(false);
  const location = useLocation();
  const { state } = location;
  useEffect(() => {
    window.history.replaceState({}, document.title);
  }, []);
  const [message, setMessage] = useState(state?.message);
  const [messagestatus, setMessagestatus] = useState(state?.status);

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage(null);
        setMessagestatus(null);
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  const updateSidebarState = (newState) => {
    setSidebarState(newState);
  };

  const user = encStorage.getItem("user");
  const [Withdrawals, setWithdrawals] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchWithdrawals = async () => {
    const token = encStorage.getItem("token");
    try {
      const response = await axios.get(GET_WITHDRAWALS, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setWithdrawals(response.data.withdrawals);
    } catch (error) {
      console.error("Error fetching Withdrawals:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchWithdrawals();
  }, []);

  const [showMessage, setShowMessage] = useState(true);

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setShowMessage(false);
        setMessage("");
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  return (
    <>
      <Header updateState={updateSidebarState} />
      <div id="layoutSidenav">
        <Sidebar props={SidebarState} />
        <div id="layoutSidenav_content" className="layout-content">
          <main>
            <div className="container-fluid px-4">
              {showMessage && message && (
                <Msgalert message={message} status={messagestatus} />
              )}
              <div className="d-flex">
                <h3 className="mt-4 w-75">Withdrawals</h3>
                <div className="mt-auto me-0 w-25 d-flex justify-content-end">
                  <Link
                    to="/withdrawal/create"
                    className="btn btn-primary"
                    title="New"
                  >
                    <span className="d-md-inline">Withdraw</span>
                  </Link>
                </div>
              </div>
              <ol className="breadcrumb mb-4">
                <li className="breadcrumb-item">
                  <Link to="/withdrawals">Listing</Link>
                </li>
              </ol>
              <div className="d-flex flex-shrink-0"></div>
              <div className="card mb-4">
                <div className="card-title ps-3 pt-3 text-bold">
                  Recent Withdrawals
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table
                      className="table table-bordered table-striped w-100 align-middle"
                      id="record-table"
                    >
                      <thead>
                        <tr>
                          <th>Amount</th>
                          <th>Date</th>
                          <th>Ref No</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan="5">Loading...</td>
                          </tr>
                        ) : Withdrawals.length === 0 ? (
                          <tr>
                            <td colSpan="5" className="text-center">
                              No records found
                            </td>
                          </tr>
                        ) : (
                          Withdrawals.map((deposit) => (
                            <tr key={deposit.id}>
                              <td>
                                {deposit.currency.symbol} {deposit.amount}
                              </td>
                              <td>{deposit.transaction_date}</td>
                              <td>{deposit.reference_number || "N/A"}</td>
                              <td>
                                {deposit.status === 0
                                  ? "Pending"
                                  : deposit.status === 2
                                  ? "Approved"
                                  : "Rejected"}
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default Withdraw;
